/**
 *
 * Asynchronously loads the component for Helmeting*
 */

import { lazyLoad } from 'utils/loadable';

export const Helmeting = lazyLoad(
  () => import('./index'),
  module => module.Helmeting,
);
